import { createSelector } from 'reselect';

const getCountSelectedFilters = (state, props) => state.filters;

const compareObjects = (object1, object2) => {
    const entries = Object.entries(object1);

    const counter = entries.reduce((acc, [key, value]) => {
        if (object2.hasOwnProperty(key)) {
            const notEqual =
                JSON.stringify(value) !== JSON.stringify(object2[key]);

            if (notEqual) {
                return acc + 1;
            }
        }
        return acc;
    }, 0);

    return counter;
};

export const makeGetCountSelectedFilters = route =>
    createSelector([getCountSelectedFilters], filters => {
        return compareObjects(filters[route].selected, filters[route].initial);
    });
